import { useRef, useState } from 'react'

import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { EMPRESAS_VENTAS } from 'Constants'

import CreateFormPaymentOrders from './content/CreateFormPaymentOrders'

const CreatePaymentOrder = (props) => {
  const { open, handleClose, render, setRender } = props

  const [loading, setLoading] = useState(false)
  const formikRef = useRef(null)

  const handleSubmit = () => {
    if (formikRef.current) formikRef.current.submitForm()
  }

  return (
    <DialogComponent
      open={open}
      handleclose={handleClose}
      title="Nueva orden de pago"
      disableBackdropClick={true}
      handleclosedisabled={loading}
      disableChildHeight
      disableEscapeKeyDown
      widthLarge="500px"
      actions={
        <CancelConfirmButtons
          onClickSubmit={handleSubmit}
          onClickCancel={handleClose}
          disabledCancel={loading}
          disabledSubmit={loading}
          isLoading={loading}
          textButtonSubmit="CONFIRMAR"
        />
      }
      children={
        <CreateFormPaymentOrders
          enteprises={EMPRESAS_VENTAS}
          formikRef={formikRef}
          loading={loading}
          onClose={handleClose}
          render={render}
          setLoading={setLoading}
          setRender={setRender}
        />
      }
    />
  )
}

export default CreatePaymentOrder
